module.exports = __webpack_public_path__ + "img/pagetop.04dfe2a1.png";